import BasePropertyView from 'BasePropertyView.js';
import Template from 'behaviors/properties/main/transaction.ejs';
import selectFieldModalView from 'common-views/SelectFieldModalView.js';
import { Model }            from 'backbone';
import RestService from '../../../../service/RestService';
import listService from 'ListService.js';
import userService from 'UserService.js';
import undoService from 'UndoService.js';
import constants from 'Constants.js';
import utils from 'util/Util.js'
import textConstants from "../../../../constants/TextConstants";
//=====================================================================
//
// An instance of this view represents a connect.
//
// Casey Justus, May 15, 2016
//
//=====================================================================

const textToDisplayConnectionsDefaultOption = 'Please select one connection';
const textToDisplayEmptyConnectionsDefaultOption = 'No connections available';

class MainTransactionView extends BasePropertyView {

    initialize(opts) {

        this.options = opts || {};
        this.template = Template;
        this.tagName = 'div';
        this.id = opts.el;

        this.events = {
            'change input[type=checkbox],input[type="radio"]': 'updateValues',
            'change select': 'updateSelect',
            'change input[name="valueOfAField"]': 'updateControlValue',
            'blur input[type=text]'   : 'lostFocus',
            'focus input[type=text]'   : 'getFocus',
            'click img[name=refreshConnections]':'refreshConnections',
            'change input[type=text], textarea' : 'updateAttributes',
            'click #valueOfAFieldButton'     : 'showSelectModal'
        };

        if (!this.model.get('showErrorMessages')) {
            this.model.set('showErrorMessages', '', {silent: true})
        }


        if (this.model.get('fielddynamicurl')) {
            const id = this.model.get('fielddynamicurl');
            const obj = listService.getObject(listService.cleanId(id));
            if (obj) {
                let name = obj ? obj.model.get('name') : '';
                this.model.set('ValueOfAField', name, {silent:true});
            }
        } else {
            this.model.set('ValueOfAField', '', {silent: true});
            this.model.set('dynamicurl', 'off', {silent: true});
        }

        if (this.model.get('connectionId') &&  this.model.get('connectionId') !== 'none'){
            this.model.set({'widgetText': this.model.get('connection')});
        }

        this.listenTo(this.model, 'change', this.render);

        return this;
    }

    refreshConnections(){
        $('select[name="connection"]').empty();
        this.fetchConnections();
    }

    getConnections() {
        let connections =  JSON.parse(window.sessionStorage.getItem('pfConnections'));
        this.updateConnectionInfo(connections);
    }

    fetchConnections() {
        RestService.getConnections().then((connections)=> {
            window.sessionStorage.setItem('pfConnections', JSON.stringify(connections));
            this.updateConnectionInfo(connections);
        });
    }    

    updateConnectionInfo(connections){
        let dbConnections =  connections.filter( connection => connection['@Type'] === constants.DATABASES_GROUP_TYPE );
        let connectionSelect = $('select[name="connection"]');
        connectionSelect.empty();
        if ($.isEmptyObject(dbConnections)) {
            utils.appendOptionToSelect(connectionSelect, 'none', textToDisplayEmptyConnectionsDefaultOption, true);
        }
        else {
            utils.appendOptionToSelect(connectionSelect, 'none', textToDisplayConnectionsDefaultOption, true);
            for (let connection of dbConnections) {
                utils.appendOptionToSelect(connectionSelect, connection['@ConnectionId'], connection['@Name'], false,
                                              connection['@Type'] );
            }
        }

        // If there was already a connection chosen, select it on render.
        if(this.model.get('connectionId')){
            let optionSelected =$(`select[name='connection'] option[value='${this.model.get('connectionId')}']`);
            optionSelected.prop('selected',true);
            this.ConnectionType = $(optionSelected).attr('dataValue');

        }
    }

    updateControlValue(ev) {
        ev.preventDefault();
        var sfModal = new selectFieldModal({model: this.model});
        sfModal.render().then((selectedField)=> {
            const oldValueOfAField=this.model.get('valueOfAField');
            this.model.set('valueOfAField', selectedField,{silent:true});
            this.model.trigger('widgetTextUpdated');
            this.render();

            undoService.add({
                undo:() =>{
                    this.model.set('valueOfAField',oldValueOfAField,{silent:true});
                    this.model.trigger('widgetTextUpdated');
                    this.render();
                },
                redo:() => {
                    this.model.set('valueOfAField',value,{silent:true});
                    this.model.trigger('widgetTextUpdated');
                    this.render();
                }
            },textConstants.UNDO_PROP_CHANGE)
        });
    }

    updateValues(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal = ev.currentTarget.checked;
        const oldPropVal=this.model.get(propName);

        this.model.set(propName, propVal, {silent: true});
        this.render();

        undoService.add({
            undo:() =>{
                this.model.set(propName,oldPropVal,{silent:true});
                this.render();
            },
            redo:() => {
                this.model.set(propName,propVal,{silent:true});
                this.render();
            }
        },textConstants.UNDO_PROP_CHANGE)
    }

    updateSelect(ev){
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal = ev.currentTarget.value;
        const oldPropVal = this.model.get(propName);

        const optionSelected=$(`select[name='${propName}'] option[value='${propVal}']`);
        this.ConnectionType = $(optionSelected).attr('dataValue');

            this.model.set('connection',$(optionSelected).text(),{silent:true});
            this.model.set('connectionId',propVal,{silent:true});
            this.model.set({'widgetText': $(optionSelected).text()},{silent:true});
            this.model.trigger('widgetTextUpdated');
            this.render();
            this.checkFeatures();

            undoService.add({
                undo:() =>{
                    const optionSelected=$(`select[name='${propName}'] option[value='${oldPropVal}']`);
                    this.ConnectionType = $(optionSelected).attr('dataValue');
                    this.model.set('connection',$(optionSelected).text(),{silent:true});
                    this.model.set('connectionId',oldPropVal,{silent:true});
                    this.model.set({'widgetText': $(optionSelected).text()},{silent:true});
                    this.model.trigger('widgetTextUpdated');
                    this.render();
                    this.checkFeatures();
                },
                redo:() => {
                    const optionSelected=$(`select[name='${propName}'] option[value='${propVal}']`);
                    this.ConnectionType = $(optionSelected).attr('dataValue');
                    this.model.set('connection',$(optionSelected).text(),{silent:true});
                    this.model.set('connectionId',propVal,{silent:true});
                    this.model.set({'widgetText': $(optionSelected).text()},{silent:true});
                    this.model.trigger('widgetTextUpdated');
                    this.render();
                    this.checkFeatures();
                }
            },textConstants.UNDO_PROP_CHANGE)
        }

        showSelectModal(ev) {
            ev.preventDefault();
            const factoryKey= 'modal';
            var sfModal = new selectFieldModalView({model: new Model(), mode: 'field', target:this.model.get('factoryKey')});
            sfModal.render().then((selectedField)=>{
                const oldFieldDynamicUrl=this.model.get('fielddynamicurl');
                const oldValueOfAField=this.model.get('ValueOfAField');
                this.model.set('fielddynamicurl', selectedField.id, {silent:true});
                this.model.set('ValueOfAField', selectedField.name,{silent:true});
                this.model.trigger('widgetTextUpdated');
                this.render();
            $('#valueOfAField').val(selectedField.name);
            undoService.add({
                undo:() =>{
                    this.model.set('fielddynamicurl',oldFieldDynamicUrl,{silent:true});
                    this.model.set('ValueOfAField', oldValueOfAField);
                    this.model.trigger('widgetTextUpdated');
                    this.render();
                    $('#valueOfAField').val(oldValueOfAField);
                },
                redo:() => {
                    this.model.set('fielddynamicurl',selectedField.id,{silent:true});
                    this.model.set('ValueOfAField', selectedField.name);
                    this.model.trigger('widgetTextUpdated');
                    this.render();
                    $('#valueOfAField').val(selectedField.name);
                }
            },textConstants.UNDO_PROP_CHANGE)


        }).catch(err => console.log(err));
    }

    checkFeatures() {
        const features = userService.getUserFeatures();
        // SF Feature and WS Connection Type
        if (features.SalesForce && this.ConnectionType === '3') {
            // enabled controls
            $('#customURL').removeAttr('disabled');
            $('#valueOfAField').removeAttr('disabled');
            $('#valueOfAFieldButton').prop('disabled', '');
        } else {
            $('#customURL').attr('disabled', true);
            $('#valueOfAField').attr('disabled', true);
            $('#valueOfAFieldButton').prop('disabled', true);
        }
    }

    render() {
        if (this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }
        
        this.getConnections();
        this.checkFeatures();
        $(`input[name="customURL"]`).prop("checked", this.model.get('customURL'));        

        this.delegateEvents();
        return this;
    }

}

export default MainTransactionView;
